<template>
  <div>
    <CustomTab
      content-class="mt-3"
      nav-class="nav-vue-underline"
      :no-nav-style="true"
    >
      <CustomTabItem class="mt-2" title="Información General">
        <div class="row">
          <div class="col-md-12 text-bold bold mb-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Adicional del Estudiante
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3 mb-3">
                <div class="data-label">Número de Registro:</div>
                <span class="data">{{ item.studentRegisterNumber }}</span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Número de Seguro Social:</div>
                <div
                  class="font-16 font-weight-normal color-black d-flex align-items-center"
                >
                  <div class="ssn-size">{{ ssn(item.studentSSN) }}</div>
                  <div
                    class="d-flex align-items-center"
                    @click="showSSN = !showSSN"
                  >
                    <em
                      class="cursor-pointer font-16"
                      :class="{
                        'far fa-eye': !showSSN,
                        'far fa-eye-slash': showSSN,
                      }"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Estatus de Estudiante:</div>
                <span class="data">{{ item.studentStatus.name }}</span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Impedimento:</div>
                <span class="data">{{ item.studentImpediment.name }}</span>
              </div>

              <div class="col-md-3 mb-3">
                <div class="data-label">Región:</div>
                <span class="data">{{ item.region.name }}</span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Distrito:</div>
                <span class="data">{{ item.district.name }}</span>
              </div>
              <div class="col-md-6 mb-3">
                <div class="data-label">Escuela:</div>
                <span class="data">{{ item.school.name }}</span>
              </div>

              <div class="col-md-3 mb-3">
                <div class="data-label">Nombre Contacto:</div>
                <span class="data">{{ item.contact.name || '-' }}</span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Parentesco Contacto:</div>
                <span class="data">
                  {{ item.contact.value.contactRelation || '-' }}
                </span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Correo Electrónico Contacto:</div>
                <span class="data">
                  {{ item.contact.value.contactEmail || '-' }}
                </span>
              </div>
              <div class="col-md-3 mb-3">
                <div class="data-label">Teléfono Contacto:</div>
                <span class="data">
                  {{ item.contact.value.contactTelephone || '-' }}
                </span>
              </div>

              <div class="col-md-12">
                <div class="data-label">Dirección Postal:</div>
                <span class="data">
                  {{ item.studentPostalAddress || '-' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.bankRequestDate" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Solicitud al Banco
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Fecha de Solicitud al Banco:</div>
                <span class="data">{{ item.bankRequestDate | date }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.receptionDate" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Recibida en SAEE
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Fecha de Recibida en SAEE:</div>
                <span class="data">{{ item.receptionDate | date }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">¿Qué se recibió?:</div>
                <span class="data">{{ item.receptionType }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">
                  Fecha de Recibo
                  {{
                    item.receptionType == ByReceptionType.PIN
                      ? 'de Tarjeta'
                      : item.receptionType == ByReceptionType.Tarjeta
                      ? 'de PIN'
                      : ''
                  }}:
                </div>
                <span class="data">
                  {{ item.additionalReceptionDate | date }}
                </span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Comentario:</div>
                <span class="data">{{ item.receptionComment || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.cseeDeliveryDate" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Entregada al CSEE
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Fecha de Entregada al CSEE:</div>
                <span class="data">{{ item.cseeDeliveryDate | date }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">CSEE:</div>
                <span class="data">{{ item.cseeDeliveryType.name }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Recibido por:</div>
                <span class="data">{{ item.cseeReceivedByName }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.deliveryDate" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Entregada
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Fecha:</div>
                <span class="data">{{ item.deliveryDate | date }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Método de Entrega:</div>
                <span class="data">{{ item.deliveryMethod.name }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Comentario:</div>
                <span class="data">{{ item.deliveryComment || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="item.status.id === CardManagementStatus.Archivada"
          class="row"
        >
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información Archivada
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="data-label">Comentario:</div>
                <span class="data">{{ item.archiveComment || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.cancellationDate" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Informacion de Cancelación
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <div class="data-label">Fecha:</div>
                <span class="data">{{ item.cancellationDate | date }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Número de Tarjeta:</div>
                <span class="data">{{ item.cancellationCardNumber }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Razón:</div>
                <span class="data">
                  {{
                    item.cancellationBalance >= 0
                      ? item.cancellationReason
                      : 'Reclamación'
                  }}
                </span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Balance:</div>
                <span class="data">
                  {{ cancellationBalance }}
                </span>
              </div>
              <div class="col-md-12 mt-3">
                <div class="data-label">Comentario:</div>
                <span class="data">{{ item.cancellationComment || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.claims.length" class="row">
          <div class="col-md-12 text-bold bold mb-3 mt-3">
            <i class=" fa fa-info-circle color-orange" />
            Información de Reclamaciones
          </div>
          <div class="col-md-12">
            <callout
              v-for="claim in item.claims"
              :key="claim.id"
              class-main="mb-3"
              :has-border="false"
              :has-toggle="false"
            >
              <div class="row">
                <div class="col-md-3">
                  <div class="data-label">Fecha:</div>
                  <span class="data">{{ claim.date | date }}</span>
                </div>
                <div class="col-md-3">
                  <div class="data-label">Tipo:</div>
                  <span class="data">{{ claim.type.name || '-' }}</span>
                </div>
                <div class="col-md-3">
                  <div class="data-label">Razón:</div>
                  <span class="data">{{ claim.reason.name || '-' }}</span>
                </div>
                <div class="col-md-3">
                  <div class="data-label">Comentario:</div>
                  <span class="data">{{ claim.comment || '-' }}</span>
                </div>
              </div>
            </callout>
          </div>
        </div>
      </CustomTabItem>
      <CustomTabItem class="mt-2" title="Historial">
        <div>
          <div class="col-md-12 text-bold bold mb-3">
            <i class=" fa fa-info-circle color-orange" />
            Historial de Estatus
          </div>
          <History :card="item" />
        </div>
      </CustomTabItem>
    </CustomTab>
  </div>
</template>

<script>
import { CustomTab, CustomTabItem } from 'custom-tabs';
import History from './History';
import CardManagementStatus from '@/utils/constants/CardManagementStatus';

const ByReceptionType = {
  PIN: 'PIN',
  Tarjeta: 'Tarjeta',
};

export default {
  name: 'AdditionalInfo',
  components: {
    CustomTab,
    CustomTabItem,
    History,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
      require: true,
    },
  },
  data: () => ({
    showSSN: false,
    ByReceptionType,
  }),
  computed: {
    CardManagementStatus() {
      return CardManagementStatus;
    },
    ssn() {
      return (value) =>
        !this.showSSN
          ? this.$options.filters.ssn(value).toUpperCase()
          : value.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
    },
    canViewSSN() {
      return this.userHasPermissions(
        'menu.scholarship.cardhandling.canviewssn'
      );
    },
    cancellationBalance() {
      if (this.item.cancellationBalance >= 0)
        return this.$options.filters.price(this.item.cancellationBalance);

      return '-';
    },
  },
};
</script>
<style scoped lang="scss">
.ssn-size {
  min-width: 115px;
}
</style>
